module.exports = __webpack_public_path__ + "img/preferences_illustration_calendar.1a98893e.png";